import { render, staticRenderFns } from "./item_dropdown.vue?vue&type=template&id=0e766bda"
import script from "./item_dropdown.vue?vue&type=script&lang=ts"
export * from "./item_dropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports